import React from 'react';
import { useTranslation } from 'react-i18next';

import AppTooltip from '@/components/app-tooltip/AppTooltip';

import { FORMAT_DATE_EN_HH_MM_SS } from '@/utils/constants/AppConstants';
import { DataViewer } from '@/utils/helpers/common';

interface IEditHistoryData {
  createdDate?: string;
  createdName?: string;
  updatedDate?: string;
  updatedName?: string;
  publishedDate?: string;
  publishedName?: string;
}

interface IEditHistoryProps {
  data: IEditHistoryData;
  className?: string;
  showCreateTime?: boolean;
  showPublicTime?: boolean;
  labelCreateName?: string;
  labelCreateDate?: string;
}

const EditHistory = (props: IEditHistoryProps) => {
  const { t } = useTranslation();
  const { showCreateTime = true, showPublicTime = false, labelCreateName, labelCreateDate } = props;
  const { createdName, createdDate = '', updatedName, updatedDate = '', publishedName, publishedDate = '' } = props.data;

  const truncateText = (text?: string, maxLength = 20) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  return (
    <div className={`flex justify-end gap-4 mb-4 ${props.className}`}>
      <div className='flex flex-col gap-2 items-start font-normal text-[#525A68] leading-[19px]'>
        {showCreateTime && (
          <AppTooltip className='truncate block w-full text-[12px] body-400' title={DataViewer.localTimeBy(createdDate, FORMAT_DATE_EN_HH_MM_SS)}>
            {`${labelCreateDate ?? t('master_data:created_date')}: ${truncateText(DataViewer.localTimeBy(createdDate, FORMAT_DATE_EN_HH_MM_SS), 20)}`}
          </AppTooltip>
        )}
        {showPublicTime ? (
          <AppTooltip className='truncate block w-full text-[12px] body-400' title={DataViewer.localTimeBy(publishedDate, FORMAT_DATE_EN_HH_MM_SS)}>
            {`${t('master_data:public_date')}: ${truncateText(DataViewer.localTimeBy(publishedDate, FORMAT_DATE_EN_HH_MM_SS), 20)}`}
          </AppTooltip>
        ) : (
          <AppTooltip className='truncate block w-full text-[12px] body-400' title={DataViewer.localTimeBy(updatedDate, FORMAT_DATE_EN_HH_MM_SS)}>
            {`${t('master_data:date_updated')}: ${truncateText(DataViewer.localTimeBy(updatedDate, FORMAT_DATE_EN_HH_MM_SS), 20)}`}
          </AppTooltip>
        )}
      </div>
      <div className='flex flex-col gap-2 items-start font-normal text-[#525A68] leading-[19px]'>
        {showCreateTime && (
          <AppTooltip className='truncate block w-full text-[12px] body-400' title={DataViewer.display(createdName)}>
            {`${labelCreateName ?? t('master_data:author')}: ${truncateText(DataViewer.display(createdName), 20)}`}
          </AppTooltip>
        )}
        {showPublicTime ? (
          <AppTooltip className='truncate block w-full text-[12px] body-400' title={DataViewer.display(publishedName)}>
            {`${t('master_data:publisher')}: ${truncateText(DataViewer.display(publishedName), 20)}`}
          </AppTooltip>
        ) : (
          <AppTooltip className='truncate block w-full text-[12px] body-400' title={DataViewer.display(updatedName)}>
            {`${t('master_data:updater')}: ${truncateText(DataViewer.display(updatedName), 20)}`}
          </AppTooltip>
        )}
      </div>
    </div>
  );
};

export default EditHistory;
